















import { Component, Vue } from "vue-property-decorator";
import authentication from '@/configuration/authentication';

@Component
export default class SmartCollabError extends Vue {
    backToLogin() {
        authentication.logout();
    }
}
